// extracted by mini-css-extract-plugin
export default {"flash":"ErrorMessage-module__flash--Fb4_Y"};